module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rN6Zcy/media/FC-9781528916400.jpg?1708094026330",
      "alt": "This image is the cover for the book Pandemonium"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pandemonium\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In a world transformed by apocalypse, the familiar landscapes of life are forever altered. Power struggles dominate the scorched continent as the Theodolis and Razors clash for dominance, while the Settlers and Wanderers yearn for a lasting peace. Amidst the turmoil, Oda, a determined Settler, is captured by Kemp, the tyrannical leader of the Razor colonies. Held in his cruel grasp, she becomes a pawn in his games of power and possession. As she confronts the grim rituals of adulthood under Kemp’s rule, Oda grapples with her identity, fighting to preserve her mind from his twisted machinations. The overgrown wilderness offers both threat and solace as Oda seeks an escape. Along her perilous journey, unexpected love emerges, alongside a deep longing for harmony. But in a land where passions run rampant and violence is the new normal, revenge looms large, and every breath could be her last.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charlotte Elwood\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Charlotte Elwood is an Australian author whose life story is as captivating as the tales she weaves. Born into the challenges of poverty, she exemplifies resilience, determination, and the unwavering pursuit of knowledge. Charlotte’s sense of adventure, hope, and boundless curiosity have driven her to explore the darkest corners of humanity’s stories, shedding light on the misunderstood and marginalized. With a heart as kind as it is diligent, she embodies the belief that even the most challenging circumstances can fuel the brightest aspirations for the future.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0